import api from '../../../core/api/client';

const BASE = '/design-templates';
const path = (id) => `${BASE}/${encodeURIComponent(id)}`;

const toApiError = (error) => {
  if (error?.response) {
    const d = error.response.data;
    return {
      status: error.response.status,
      message: d?.detail || d?.message || d?.error || error.message || 'Request failed',
      data: d,
    };
  }
  return { status: 0, message: error?.message || 'Unexpected error', data: null };
};

const wrap = async (fn) => {
  try { return await fn(); }
  catch (error) { throw toApiError(error); }
};

export const designTemplatesService = {
  async getFormats() {
    return wrap(async () => {
      const response = await api.get(`${BASE}/formats`);
      return response.data;
    });
  },

  async list({ category, isInspiration, platform, tag } = {}) {
    return wrap(async () => {
      const params = {};
      if (category !== undefined && category !== '')    params.category      = category;
      if (isInspiration !== undefined)                  params.isInspiration = isInspiration;
      if (platform !== undefined && platform !== '')    params.platform      = platform;
      if (tag !== undefined && tag !== '')              params.tag           = tag;
      const response = await api.get(BASE, { params });
      return response.data;
    });
  },

  async get(templateId) {
    return wrap(async () => {
      const response = await api.get(path(templateId));
      return response.data;
    });
  },

  async update(templateId, updates) {
    return wrap(async () => {
      const response = await api.patch(path(templateId), updates);
      return response.data;
    });
  },

  async delete(templateId) {
    return wrap(async () => {
      const response = await api.delete(path(templateId));
      return response.data;
    });
  },

  // Register via external URL (Figma, Drive, Behance, etc.)
  async link(data) {
    return wrap(async () => {
      const response = await api.post(`${BASE}/link`, data);
      return response.data;
    });
  },

  // Multipart file upload
  async upload(formData) {
    return wrap(async () => {
      const response = await api.post(`${BASE}/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    });
  },

  // Log a download (increments downloadCount + lastUsedAt)
  async logDownload(templateId) {
    return wrap(async () => {
      const response = await api.post(`${path(templateId)}/download`);
      return response.data;
    });
  },
};

export const FORMAT_CATEGORIES = [
  'adobe', 'figma', 'sketch', 'affinity', 'procreate', 'raster',
  'vector', 'motion', 'threed', 'font', 'bundle', 'other',
];

export const DESIGN_CATEGORIES = [
  'poster', 'social_post', 'logo', 'banner', 'flyer', 'brochure',
  'presentation', 'email', 'ui', 'illustration', 'motion', 'inspiration', 'other',
];

export const FORMAT_CATEGORY_META = {
  adobe:     { label: 'Adobe',     color: '#ff0000', bg: '#fff0f0' },
  figma:     { label: 'Figma',     color: '#a259ff', bg: '#f5f0ff' },
  sketch:    { label: 'Sketch',    color: '#fa6400', bg: '#fff4ee' },
  affinity:  { label: 'Affinity',  color: '#4e56f5', bg: '#f0f0ff' },
  procreate: { label: 'Procreate', color: '#1d1d1f', bg: '#f5f5f7' },
  raster:    { label: 'Raster',    color: '#0066cc', bg: '#e8f4ff' },
  vector:    { label: 'Vector',    color: '#007a00', bg: '#e8f7e8' },
  motion:    { label: 'Motion',    color: '#b5179e', bg: '#fce8f8' },
  threed:    { label: '3D',        color: '#ff6b35', bg: '#fff2ec' },
  font:      { label: 'Font',      color: '#6b6b6b', bg: '#f5f5f5' },
  bundle:    { label: 'Bundle',    color: '#8b5cf6', bg: '#f5f0ff' },
  other:     { label: 'Other',     color: '#9ca3af', bg: '#f5f5f5' },
};
